import { render, staticRenderFns } from "./CopyLimits.vue?vue&type=template&id=436b3314&scoped=true&"
import script from "./CopyLimits.vue?vue&type=script&lang=js&"
export * from "./CopyLimits.vue?vue&type=script&lang=js&"
import style0 from "./CopyLimits.vue?vue&type=style&index=0&id=436b3314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b3314",
  null
  
)

export default component.exports